import { render, staticRenderFns } from "./ClinicPageManagePrintables.vue?vue&type=template&id=58d9370c"
import script from "./ClinicPageManagePrintables.vue?vue&type=script&lang=js"
export * from "./ClinicPageManagePrintables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports